<template>
  <div id="app">
    <Header routeValue="4-3"></Header>
    <content class="help-details">
      <div :class="scroll>53?'banner_scroll':'banner_box'">
        <div class="search_section" :style="{marginTop:scroll>53?'72px':'100px'}">
           <span>
            <a-input
              placeholder="Search for answers"
              @pressEnter="onSearch"
              allow-clear>
              <a-icon slot="prefix" type="search"/>
            </a-input>
          </span>
        </div>
      </div>
      <div class="container_des">
        <div class="nav_bar">
          <img src="@/assets/icon/arrow2.png" style="margin-right: 10px">
          {{ categoryNames || 'N/A' }}
        </div>
        <div class="content_box">
          <div style="width: 344px;margin-right: 20px">
            <div :class="scroll>53?'item_scroll':'item_view'">
              <div class="item_l" v-for="item in dataList">
                <a :href="item.prefix + item.link">
                  <div class="divider" :style="{background:item.isSelected?'#2D3E50':''}"></div>
                  <div class="title" :style="{fontWeight:item.isSelected?'bold':''}">
                    {{ item.name }}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="item_view" :style="{marginTop:scroll>53?'240px':'' }">
            <div class="iframe_box">
              <div class="name">{{ htmlTitle }}</div>
            </div>
            <div class="item_r">
              <iframe
                ref="myIframe"
                :srcdoc="htmlString"
                @load="adjustIframeSize"
                scrolling='no'
                style="border: none; width: 100%">
              </iframe>
            </div>
          </div>

        </div>

      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {get} from '@/api'
import {getSeoLinkName} from '@/utils/utils'

export default {
  name: 'HelpDetails',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      link: '',
      scroll: 0,
      htmlString: '',
      htmlTitle: '',
      categoryNames: '',
      dataList: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  created () {
    this.link = this.$route.params.link
    this.listHelpIndex()
  },
  methods: {
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    },
    listHelpIndex () {
      get('/merchant/message/help/index')
        .then(response => {
          this.dataList = response.data
          this.dataList.forEach(item => {
            item.link = getSeoLinkName(item.name)
            item.prefix = '/help/list/'
          })
          this.getHelpDetail(this.link)
        }).catch(error => {
        console.error(error)
      })

    },
    getHelpDetail (link) {
      get(`/merchant/message/help/detail/byLink/${link}`)
        .then(response => {
          if (response.code === 200) {
            this.categoryNames = response.data.categoryNames + ''
            this.dataList.forEach((item => {
              item['isSelected'] = getSeoLinkName(this.categoryNames) === item.link
            }))
            this.htmlTitle = response.data.title
            this.htmlString = '<link rel="preconnect" href="https://fonts.googleapis.com">\n' +
              '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>\n' +
              '<link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet"> ' +
              '<style type="text/css">table {border-collapse: collapse;font-family: HarmonyOS Sans SC}</style>' + response.data.desc
          }
        }).catch(error => {
        console.error(error)
      })
    },
    onSearch (row) {
      window.location.href = `/help/search-results?term=${row.target.value}`
    },
    adjustIframeSize () {
      let that = this
      const iframe = this.$refs.myIframe
      // 在 iframe 加载完成后执行的函数
      iframe.onload = function () {
        // 获取 iframe 中的文档对象
        const doc = iframe.contentDocument || iframe.contentWindow.document
        // 获取所有 img 元素
        const images = doc.querySelectorAll('img')
        const srcUrls = Array.from(images).map(item => item.src)
        // 循环处理每个图片元素
        images.forEach(function (img, index) {
          // 获取图片原始宽度和高度
          const originalWidth = img.width
          const originalHeight = img.height
          // 计算等比例缩放后的高度
          const newWidth = 668
          const aspectRatio = newWidth / originalWidth
          const newHeight = Math.round(originalHeight * aspectRatio)
          // 设置图片的新宽度和高度
          img.width = newWidth
          img.height = newHeight
          img.style.cursor = 'pointer'
          img.addEventListener('click', function () {
            that.$viewerApi({
              options: {initialViewIndex: index},
              images: srcUrls
            })
          })
        })
        if (doc) {
          const body = doc.body
          body.style.fontFamily = 'IBM Plex Sans'
          const html = doc.documentElement
          const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
          iframe.style.height = `${height}px`
        }
      }

    },
  },
}
</script>
<style scoped lang="less">
.help-details {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  min-height: 855px;
  font-family: HarmonyOS Sans SC;

  .banner_scroll {
    width: 100%;
    height: 140px;
    background-image: url(../../assets/icon/banner_bg2.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: fixed;
    top: 20px;
    z-index: 100;
  }

  .banner_box {
    height: 190px;
    background-image: url(../../assets/icon/banner_bg1.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    //margin-top: 72px;
  }


  .search_section {
    width: 1052px;
    display: flex;
    flex-direction: column;
    margin-left: 425px;
    margin-top: 100px;

    /deep/ .ant-input {
      height: 50px;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 400;
      background: #FFFFFF;
    }
  }

  .container_des {
    position: relative;
    width: 100%;
    max-width: 1052px;
    margin-left: 425px;
    float: none !important;
    display: flex;
    flex-wrap: wrap;

    .nav_bar {
      font-weight: 400;
      font-size: 13px;
      margin-top: 17px;
      color: #33475B;
    }

    .content_box {
      width: 100%;
      margin-top: 52px;
      display: flex;
      margin-bottom: 52px;

      .item_scroll {
        position: fixed;
        top: 170px;
      }

      .item_view {
        display: flex;
        flex-direction: column;
      }

      .item_l {
        width: 344px;
        margin-right: 20px;

        a:hover {
          .divider {
            width: 3px;
            height: 25px;
            background: #2D3E50;
          }
        }

        a {
          width: 240px;
          height: 40px;
          display: flex;
          align-items: center;
          cursor: pointer;

          .divider {
            width: 3px;
            height: 25px;
            background: transparent;
          }

          .title {
            font-weight: 400;
            font-size: 14px;
            color: #33475B;
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .iframe_box {
        width: 688px;
        margin-bottom: 10px;

        .name {
          font-weight: 500;
          font-size: 32px;
          margin-left: 7px;
          color: #33475B;
          line-height: 35px;
        }

      }

      .item_r {
        width: 688px;

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/HelpDetails.vue